import { TablelistProApi } from '@lib/api'
import { VenueEvent } from 'types/model'

class EventApi extends TablelistProApi<VenueEvent> {
  constructor() {
    super('/event')
  }
}

export const eventApi = new EventApi()
